__turbopack_context__.v({
  "directions": "HowToGetThere-module-scss-module__524jYG__directions",
  "icon": "HowToGetThere-module-scss-module__524jYG__icon",
  "list": "HowToGetThere-module-scss-module__524jYG__list",
  "text": "HowToGetThere-module-scss-module__524jYG__text",
  "title": "HowToGetThere-module-scss-module__524jYG__title",
});
